export default __webpack_public_path__ + "static/media/diente.ed123d88.png";